import { useState, useRef, useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { setUpperPopup } from '../../store/reducers/general.js'
import { editTeam } from '../../store/reducers/user.js'
import { teamService } from '../../services/team.js'
import { uploadFile } from "../../services/upload.js"
import { Loader } from '../loader.jsx'

export function Details({ team, isAdmin }) {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const [loader, setLoader] = useState(false)
    const [editIcon, setEditIcon] = useState(false)
    const [editName, setEditName] = useState(false)
    const name = useRef()

    useEffect(() => {
        if (name.current) {
            name.current.value = team.channelName
            name.current.focus()
        }
    }, [editName])

    const onNameChange = async (ev) => {
        ev.preventDefault()
        try {
            const newName = name.current.value
            if (!newName || newName === team.channelName) return
            if (newName.length > 20 || newName.length < 2) return dispatch(setUpperPopup('errorName'))
            await teamService.editTeam({ channelName: newName }, team._id)
            await queryClient.invalidateQueries({ queryKey: ['teams-admin'] })
            let newTeam = { ...team, channelName: newName }
            dispatch(editTeam(newTeam))
            setEditName(false)
        }
        catch {
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const onImageChange = async (ev) => {
        try {
            setLoader(true)
            if (!ev.target.files[0]) return setLoader(false)
            if (!ev.target.files[0].type.startsWith('image/')) {
                setLoader(false)
                dispatch(setUpperPopup('image-only'))
                return
            }
            const { secure_url } = await uploadFile(ev.target.files[0])
            await teamService.editTeam({ channelImage: secure_url }, team._id)
            await queryClient.invalidateQueries({ queryKey: ['teams-admin'] })
            let newTeam = { ...team, channelImage: secure_url }
            dispatch(editTeam(newTeam))
            setLoader(false)
        }
        catch (err) {
            dispatch(setUpperPopup('errorServer'))
            setLoader(false)
        }
    }

    return <div className='channel'>
        {isAdmin ? <div className='img-wrapper'>
            {loader ? <Loader /> : <>
                <input type="file" className="non-appear" accept="image/*" id='image-edit' onChange={onImageChange} />
                <label htmlFor='image-edit'>
                    <img onMouseEnter={() => setEditIcon(true)} onMouseLeave={() => setEditIcon(false)} src={team.channelImage} alt='channel' />
                    {editIcon && <span className="edit-icon material-symbols-outlined" onMouseEnter={() => setEditIcon(true)} onMouseLeave={() => setEditIcon(false)}>add_a_photo</span>}
                </label>
            </>}
        </div> : <div className='img-wrapper'>
            <img src={team.channelImage} alt='channel' />
        </div>}
        <div className='name-wrapper'>
            {isAdmin && <div className='edit-button'><span className="material-symbols-outlined" onClick={() => setEditName(!editName)}>{editName ? 'close' : 'edit'}</span></div>} 
            {editName ? <form onSubmit={onNameChange} className='edit-name'>
                <input className='channel-name border' maxLength={20} ref={name} />
                <button className='edit-button'><span className="material-symbols-outlined">check</span></button>
            </form> :
                <p className='channel-name'>{team.channelName}</p>}
        </div>
    </div>
}